export interface ContractInterfaceBase {
    id: number;
    statut: string;
    typeLigne: string;
    numeroTel: string;
    partitionSic: string;
    ligneMarche: string;
    idPfs: string;
    _links: any;
    _actions: any;
    abonnement: any;
    utilisateur: any;
    contratsAppaireDataPartagee: any;
}

export enum REFCLI_TYPE {
    INDIVIDU = 'INDIVIDU',
    ENTREPRISE = 'ENTREPRISE',
}
